import { useContext, useEffect, useRef } from "react";
import { ConfigurationContext } from "contexts";
import { useAnalytics, useAbandonTracking } from "hooks";

/**
 *  Renders nothing. Fires the arrival event and registers the leave listener.
 *
 *  Must sit INSIDE ConfigurationContextProvider: page_view deliberately waits for the configuration
 *  to resolve, because that is when session_id first exists. Firing on mount instead would produce
 *  an event that cannot be joined to anything - and joining is the entire point.
 */
const Analytics = () => {
  const config = useContext(ConfigurationContext);
  const analytics = useAnalytics();
  const fired = useRef(false);

  useAbandonTracking();

  useEffect(() => {
    if (fired.current) return;
    if (!config) return; // configuration has not come back yet

    fired.current = true;
    analytics.pageView({
      // Which steps this visitor will actually be shown, so the funnel can tell a detection
      // flow from a network-test-only flow rather than lumping them together.
      has_app_step: !!(config.steps && config.steps.appDetection),
      has_network_step: !!(config.steps && config.steps.networkDetection),
      os: config.os || "",
      browser: config.browser || "",
    });
  }, [config, analytics]);

  return null;
};

export default Analytics;
